import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../auth';
import { Card } from '../components/ui/card';
import { Users, MailQuestion, Cake, Soup, Sparkles, AlertCircle } from 'lucide-react';

export default function SegmentsPage() {
  const [segments, setSegments] = useState({
    lavash_only: [], desserts_only: [], cheese_only: [], mixed: [], inactive: []
  });

  useEffect(() => {
    axios.get(`${API}/analytics/segments`).then(r => setSegments(r.data)).catch(console.error);
  }, []);

  const segmentInfo = [
    { key: 'mixed', label: 'Универсалы (Лаваш + Другое)', icon: Sparkles, color: 'amber', desc: 'Заказывают всё подряд' },
    { key: 'lavash_only', label: 'Только Лаваш', icon: Soup, color: 'orange', desc: 'Идеальная аудитория для рекламы десертов' },
    { key: 'desserts_only', label: 'Только Десерты', icon: Cake, color: 'pink', desc: 'Покажите им новый лаваш' },
    { key: 'cheese_only', label: 'Только Сыр', icon: Users, color: 'yellow', desc: 'Любители сыра' },
    { key: 'inactive', label: 'Спящие (14+ дней)', icon: AlertCircle, color: 'red', desc: 'Срочно реактивировать!' },
  ];

  const formatCompact = (val) => {
    const n = Number(val || 0);
    if (n >= 1000000) return `₩${(n / 1000000).toFixed(1)}M`;
    if (n >= 1000) return `₩${(n / 1000).toFixed(0)}K`;
    return `₩${n}`;
  };

  const copySegmentList = (companies) => {
    const text = companies.map(c => `${c.client_code} - ${c.company_name}`).join('\n');
    navigator.clipboard.writeText(text);
    alert('Список скопирован! Можете использовать для рассылки.');
  };

  return (
    <div className="space-y-6" data-testid="segments-page">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 tracking-tight">Сегменты клиентов</h1>
        <p className="text-gray-500 mt-1">Умная группировка для целевых рассылок</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {segmentInfo.map(seg => {
          const Icon = seg.icon;
          const list = segments[seg.key] || [];
          return (
            <Card key={seg.key} className="p-5 cff-hover-lift" data-testid={`segment-${seg.key}`}>
              <div className="flex items-start gap-3 mb-3">
                <div className={`bg-${seg.color}-50 p-2 rounded-md`}>
                  <Icon className={`h-5 w-5 text-${seg.color}-600`} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-gray-900">{seg.label}</p>
                  <p className="text-xs text-gray-500 mt-0.5">{seg.desc}</p>
                </div>
                <div className="text-2xl font-bold cff-text-numeric">{list.length}</div>
              </div>
              {list.length > 0 && (
                <>
                  <div className="space-y-1.5 max-h-48 overflow-y-auto mb-3 pt-2 border-t border-gray-100">
                    {list.slice(0, 10).map(c => (
                      <div key={c.company_id} className="flex justify-between text-xs">
                        <span className="text-gray-700">{c.company_name}</span>
                        <span className="text-gray-400 font-mono">{c.client_code}</span>
                      </div>
                    ))}
                    {list.length > 10 && <p className="text-xs text-gray-400 text-center">+{list.length - 10}</p>}
                  </div>
                  <button
                    onClick={() => copySegmentList(list)}
                    className="w-full text-xs py-2 bg-gray-100 hover:bg-gray-200 rounded-md font-medium"
                    data-testid={`copy-${seg.key}`}
                  >
                    📋 Копировать список
                  </button>
                </>
              )}
              {list.length === 0 && (
                <p className="text-xs text-gray-400 text-center py-4">Нет клиентов в этом сегменте</p>
              )}
            </Card>
          );
        })}
      </div>
    </div>
  );
}
